export const colorInfo = '#84A1D6';
export const colorWarning = '#E6C091';
export const colorError = '#D69484';

export const BookingValidationErrors = {
  BOOKING_NO_GROUP: {
    value: 3001,
    translationKey: 'settlement.objectsDoNotBelongToGroup',
    icon: 'mdi-home-group',
    iconColor: colorError
  },
  BOOKING_NO_CONSUMPTIONS: {
    value: 2002,
    translationKey: 'settlement.missingConsumption',
    icon: 'mdi-flash-alert',
    iconColor: colorWarning
  },
  BOOKING_NO_MAIL_TO_OWNER: {
    value: 2003,
    translationKey: 'settlement.mailNotYetSentToOwner',
    icon: 'mdi-email-alert',
    iconColor: colorInfo
  },
  BOOKING_NO_NON_DEPOSIT_PAYMENT: {
    value: 2004,
    translationKey: 'settlement.noNonDepositPayment',
    icon: 'mdi-credit-card-outline',
    iconColor: colorWarning
  },
  BOOKING_NOTE_PRESENT: {
    value: 2005,
    translationKey: 'settlement.notePresent',
    icon: 'mdi-message-alert',
    iconColor: colorWarning
  },
  BOOKING_CHECKOUT_IN_FUTURE: {
    value: 2006,
    translationKey: 'settlement.checkoutInFuture',
    icon: 'mdi-calendar-alert',
    iconColor: colorInfo
  },
  BOOKING_TOTAL_DO_NOT_MATCH: {
    value: 2007,
    translationKey: 'settlement.totalDoNotMatch',
    icon: 'mdi-database-alert',
    iconColor: colorError
  },
  BOOKING_DUE_DATE_AFTER_CHECKIN: {
    value: 2008,
    translationKey: 'settlement.dueDateAfterCheckin',
    icon: 'mdi-credit-card-clock-outline',
    iconColor: colorInfo
  },
  BOOKING_CANCELED: {
    value: 2009,
    translationKey: 'booking.canceledBooking',
    icon: 'mdi-book-cancel',
    iconColor: colorError
  },
  BOOKING_OPEN_TRANSACTION: {
    value: 2010,
    translationKey: 'booking.openTransaction',
    icon: 'mdi-credit-card-clock-outline',
    iconColor: colorWarning
  },
  BOOKING_GUEST_MISSING_BANK_DETAILS: {
    value: 2011,
    translationKey: 'booking.guestBankDetailsMissing',
    icon: 'mdi-credit-card-remove',
    iconColor: colorError
  },
  BOOKING_MISSING_DEPOSIT_PAYMENT: {
    value: 2012,
    translationKey: 'booking.missingDeposit',
    icon: 'mdi-credit-card-clock',
    iconColor: colorWarning
  }
}
